import { CKBox, CKCheckbox, CKCheckboxProps } from 'clearkit';

type UpgradePlanItemProps = Pick<CKCheckboxProps, 'checked'> & {
  className?: string;
  children?: React.ReactNode;
  title: string;
  onChange: (value: boolean) => void;
};

export default function UpgradePlanItem({
  children,
  onChange,
  title,
  checked,
}: UpgradePlanItemProps) {
  return (
    <CKBox className="p-4">
      <CKCheckbox
        checked={checked}
        gap="1rem"
        onChange={(event) => onChange(event.target.checked)}
      >
        <span className="block mb-1 font-medium">{title}</span>
        <span className="text-base leading-normal">{children}</span>
      </CKCheckbox>
    </CKBox>
  );
}
